<div id="fullwidth">
    <app-background-carousel></app-background-carousel>
    <app-confirm-password [email]="email" [token]="token" [create]="true"></app-confirm-password>
</div>